import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../../providers/ortak';

/**
 * Generated class for the GrupEkleGuncellePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-grup-ekle-guncelle',
  templateUrl: 'grup-ekle-guncelle.html',
})
export class GrupEkleGuncellePage {
  gruplar:any={ID:-1,Adi:""};
  grup:any={};
  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
      if (navParams.get("grupVw") != null) {
        this.grup = navParams.get("grupVw");
        var data = new FormData();
        data.append("Grup_id", this.grup.ID);
        this.bllOrtak.islem(data, "GrupGetirByID", "", false).then(a => {
          var Sonuc = <any>a;
          this.gruplar = Sonuc.SonucObject;
         
        }
        )
      }
  }

  ionViewDidLoad() {
 
  }
  boslukKontrol() {
    var mesaj = "";
    
    if (this.gruplar.Adi == null || this.gruplar.Adi == "") {
      mesaj = mesaj + "Lütfen Grup adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
   
    if (this.boslukKontrol()) {
      formData.append("Grup_json", JSON.stringify(this.gruplar));
     
      this.bllOrtak.islem(formData, "CariGrupEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
       

      })
    }
    this.cikis();
    }
    cikis()
    {
      this.viewCtrl.dismiss();
    }


}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/CariGrupIslemleri/grup-ekle-guncelle/grup-ekle-guncelle.ts